import AirQualityMain from "@components/AirQualityMain";
const AirQuality: React.FC = () => {
  return (
    <Container>
      <AirQualityMain />
    </Container>
  );
};

export default AirQuality;
